import { Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";
import { WellLevelsView } from "../../components/WellLevelsView/WellLevelsView";
import { useLocalStorageState } from "../../hooks/localStorage";
import { GenericDashboardView } from "../GenericDashboardView/GenericDashboardView";
import { Introduction } from "../Introduction/Introduction";
import { SitesColorsManager } from "../SitesColorsManager/SitesColorsManager";
import { SummaryView } from "../SummaryView/SummaryView";

export function Dashboard() {
  const [dashBoardSettings, handleDashboardSettingsUpdate] = useLocalStorageState({
    key: "dashboard",
    value: { tabIndex: 0 },
  });

  return (
    <Tabs index={dashBoardSettings.tabIndex} onChange={(tabIndex) => handleDashboardSettingsUpdate({ tabIndex })}>
      <TabList
        sx={{
          scrollbarWidth: "none",
          "::-webkit-scrollbar": {
            display: "none",
          },
        }}
      >
        <Tab>Introduction</Tab>
        <Tab>Summary</Tab>
        <Tab>Surface Water</Tab>
        <Tab>Ground Water</Tab>
        <Tab>Groundwater Well Levels</Tab>
        <Tab>Drinking Water</Tab>
        <Tab>🎨 Sites Colors</Tab>
      </TabList>

      <TabPanels>
        <TabPanel>
          <Introduction />
        </TabPanel>
        <TabPanel>
          <SummaryView />
        </TabPanel>
        <TabPanel>
          <GenericDashboardView project="surfaceWater" />
        </TabPanel>
        <TabPanel>
          <GenericDashboardView project="groundWater" />
        </TabPanel>
        <TabPanel>
          <WellLevelsView />
        </TabPanel>
        <TabPanel>
          <GenericDashboardView project="drinkingWater" />
        </TabPanel>
        <TabPanel>
          <SitesColorsManager />
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
}
